define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var HelpScoutThreadModel = /** @class */ (function () {
        function HelpScoutThreadModel(data) {
            this.ConversationId = ko.observable(0);
            this.Subject = ko.observable('');
            this.Body = ko.observable('');
            this.Cc = ko.observable('');
            this.Bcc = ko.observable('');
            this.Type = ko.observable('Reply');
            this.OwnerId = ko.observable(0);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, HelpScoutThreadModel.Mapping, self);
            }
        }
        HelpScoutThreadModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new HelpScoutThreadModel(options.data);
            }
        };
        return HelpScoutThreadModel;
    }());
    return HelpScoutThreadModel;
});
//# sourceMappingURL=HelpScoutThreadModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/HelpScoutThreadModel.js
// module id = 86
// module chunks = 2